import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=4cef2a0d&scoped=true&"
import script from "./order-list.js?vue&type=script&lang=js&"
export * from "./order-list.js?vue&type=script&lang=js&"
import style0 from "./order-list.scss?vue&type=style&index=0&id=4cef2a0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef2a0d",
  null
  
)

export default component.exports